module.exports = __webpack_public_path__ + "img/layout-text-window.256b2218.svg";